import React from 'react';
import useMetaTags from '../../hooks/useMetaTags';
import Services_we_offer from '../../component/Services_Component/Services_we_offer';
import Custom_section from '../../component/Services_Component/Custom_services_section';
import Benefits_section from '../../component/Services_Component/Benefits_section';
import Boost_section from '../../component/Services_Component/Boost_section';
import Assistance_section from '../../component/Services_Component/Assistance_section';
import FAQ_section from '../../component/Services_Component/FAQ_section';
import Role_writing from '../../component/Services_Component/Role_writing';
import Handle_Largedata_section from "../../component/Services_Component/Handle_Largedata_section";
import { AssistanceSection, BenefitSection, BoostSection, CustomSection, FAQ, LargeData, ServicesSection } from '../../Data/All_Services_Data/appDevelopmentData';

const MobileAppDevelopment = () => {
    useMetaTags({
      title: "Expert Mobile App Development | iOS & Android App Solutions",
      description:
        "We design impactful mobile apps for iOS and Android that engage and grow. From idea to launch, rely on our experts to turn your app concept into a reality.",
      keywords:
        "mobile application development, mobile app development, mobile app development services, mobile app application development, app development, custom mobile app development, mobile app development agency, mobile development company, mobile app development company, app development company",
    });
    return (
      <>
        <section
          className=""
          style={{
            backgroundImage: `url('assets/img/service/serviceD.jpg')`,
            backgroundPosition: "center",
            backgroundSize: "cover",
          }}
          id="service-sec"
        >
          <div className="round-container pt-5">
            <div className="container">
              <div className="title-area text-center">
                <span className="sub-title text-white">OUR SERVICES</span>
                <h1 className="sec-title text-white">
                  Mobile App Development Overview
                </h1>
              </div>
            </div>
          </div>
        </section>
        <section className="space-extra-bottom">
          <div className="page-single">
            <div className="page-content">
              <style>{`
                    .header-section{
            display: flex;
            align-items: center;
            gap: 20px;
            margin-bottom: 30px;
        }
        .header-section img{
            height: 400px;
        }
        .header-section p{
            text-align: left;
        }

        @media only screen and (max-width: 990px) {
        .header-section{
            flex-direction: column;
        }
        .header-section img{
            height: 200px;
        }
            .header-section p{
            text-align: center;
        }
        }
                `}</style>
              {/* Intro part  */}
              <div
                className="header-section container"
                style={{ marginTop: "20px" }}
              >
                <img
                  src="assets/img/icon/appDevelop.png"
                  loading="lazy"
                  alt="heading_image"
                />
                <div>
                  <p>
                    Mobile app development is at the core of what we do as a
                    means for companies to interact with their users today. At
                    our company we focus on developing easy to use, high
                    performance mobile apps that are tailored to your needs. We
                    develop for iOS, Android, or cross platform. We see to it
                    that you have a smooth experience from concept to
                    deployment.
                  </p>
                </div>
              </div>
              {/* Custom Mobile App Development Services  */}
              <Handle_Largedata_section LargeData={LargeData} />

              {/* Different Types of Mobile Apps */}
              <Services_we_offer data={ServicesSection} />

              {/* Innovative Solutions for Mobile App Development  */}
              <Custom_section data={CustomSection} />

              {/* Why Use Us for Mobile Application Development? */}
              <Benefits_section data={BenefitSection} />

              {/* Personalized Mobile App Development */}
              <Boost_section data={BoostSection} />

              {/* Exceptional Mobile App Development Services for Hire */}
              <Assistance_section data={AssistanceSection} />

              {/* FAQ section  */}
              <FAQ_section data={FAQ} />
            </div>
          </div>
        </section>
        <div className="scroll-top">
          <svg
            className="progress-circle svg-content"
            width="100%"
            height="100%"
            viewBox="-1 -1 102 102"
          >
            <path
              d="M50,1 a49,49 0 0,1 0,98 a49,49 0 0,1 0,-98"
              style={{
                transition: "stroke-dashoffset 10ms linear 0s",
                strokeDasharray: "307.919, 307.919",
                strokeDashoffset: "307.919",
              }}
            ></path>
          </svg>
        </div>
      </>
    );
};

export default MobileAppDevelopment;